/*
    Higher order component to render react select

    takes in options to render.
*/
import React, { useCallback, useEffect, useState } from 'react';

import Select from 'react-select';

const reactSelectWithOptions = (options, componentProps = {}) => {
   return (props) => {
      const [selectedValue, setSelectedValue] = useState();
      const handleChange = useCallback((option) => {
         const value = props.isMulti || props.storeAsObject ? option : option.value;
         if (props.onChange) {
            props.onChange(value);
         }
      }, [props.onChange]);

      // For handling defaultValues
      useEffect(() => {
         if (
            (
               !props.isMulti
               && componentProps
               && componentProps.defaultValue
               && componentProps.defaultValue.value
            )
            || (
               props.isMulti
               && componentProps
               && componentProps.defaultValue
               && componentProps.defaultValue.value
            )
         ) {
            handleChange(componentProps.defaultValue);
         }
      }, []);

      useEffect(() => {
         if (props.isMulti || props.storeAsObject && props.value) {
            setSelectedValue(props.value);
         } else if (props.value && options && typeof props.value === 'string') {
            const value = options.find((option) => {
               if (option && typeof option.value === 'string') {
                  return option.value.toLowerCase() === props.value.toLowerCase();
               } else if (option && option.value) {
                  return props.value == option.value;
               } else {
                  return props.value == option;
               }
            });
            setSelectedValue(value);
         } else if (props.value && options && typeof props.value === 'number') {
            const value = options.find((option) => {
               if (option && option.value) {
                  return props.value == option.value;
               } else {
                  return props.value == option;
               }
            });
            setSelectedValue(value);
         } else {
            setSelectedValue(null);
         }
      }, [props.value, options]);

      const getOptions = () => {
         if (
            props.isMulti
            && props.maxOptionSelect
            && Array.isArray(selectedValue)
            && selectedValue.length >= props.maxOptionSelect
         ) {
            return options.map((option) => ({
               ...option,
               isDisabled: true,
               disabled: true,
               disable: true,
            }));
         } else {
            return options;
         }
      };

      return (
         <Select
            menuPlacement='auto'
            className={ `react-select-container ${ props.className ? props.className : '' }` }
            classNamePrefix='react-select'
            value={ selectedValue }
            onChange={ handleChange }
            options={ getOptions() }
            required={ props.required }
            isDisabled={ props.isDisabled || false }
            isMulti={ props.isMulti }
            { ...componentProps }
            isOptionDisabled={props.isOptionDisabled}
         />
      );
   };
};

export default reactSelectWithOptions;
